// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"42":"e4c311aa","560":"0a71c18a"}[chunkId] + ".js";
};